import React from 'react';

import './style.scss';

const MenuHeader = React.memo<React.HTMLAttributes<HTMLDivElement>>(({ className = '', ...props }) => (
  <div className={`Menu-Header${className ? ` ${className}` : ''}`} {...props}>
    {props.children}
  </div>
));

MenuHeader.displayName = 'MenuHeader';

export default MenuHeader;
